<template>
    <transition name="list">
        <div class="variants-wrapper variant-type--size" v-if="showPicker">
            <div v-if="current === activeProduct" class="variant-title " v-on:click.stop.prevent='askForVariants = !askForVariants'>
                <span class="size-box-toggle">Select Color & Size: <svg version="1.1" id="Capa_1"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                        x="0px"
                                                                        y="0px" viewBox="0 0 256 256"
                                                                        style="enable-background:new 0 0 256 256;"
                                                                        xml:space="preserve" width="13px" height="100%"
                                                                        v-bind:class="{'rotate': askForVariants}">
                    <g>
                        <g>
                            <polygon class="stchevron"
                                     points="256,79.1 225.8,48.9 128,146.7 30.2,48.9 0,79.1 128,207.1"/>
                        </g>
                    </g>
                </svg>
                </span>

                <a href="#sizeChart" class="chart text-white" @click="modalWindow()">
                    <svg  class="chart__image"  width="22" height="10" viewBox="0 0 22 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.875 0H2.125C0.953 0 0 0.897 0 2V8C0 9.103 0.953 10 2.125 10H19.875C21.047 10 22 9.103 22 8V2C22 0.897 21.047 0 19.875 0ZM19.875 8H2.125C2.068 8 2.029 7.984 2.012 7.984C2.005 7.984 2.001 7.986 2 7.992L1.988 2.046C1.995 2.036 2.04 2 2.125 2H4V5H6V2H8V6H10V2H12V5H14V2H16V6H18V2H19.875C19.954 2.001 19.997 2.028 20 2.008L20.012 7.954C20.005 7.964 19.96 8 19.875 8Z" fill="white"/>
                    </svg>

                    <span class="chart__text">Size Chart</span>
                </a>

                <div class="variant-title-picked">
                    <div class="picked-color" style="display:flex; align-items:center">
                        <p>Color:</p>
                        <div class="colors header" style="display:flex; align-items:center">
                            <div v-if="productColor()" class="color-box__color"
                                 :style="'background:' + cart.variants.color_options[0].color_code">

                            </div>
                            <div>{{ cart.getColorName }}</div>
                        </div>
                    </div>
                    <div class="picked-size">
                        <p>Size:</p>
                        <div class="sizes">

                            <div class="not-mixed">
                                {{ cart.getSizeName }}
                            </div>
<!--                            <div v-else>mixed</div>-->
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="current === activeProduct && askForVariants" class="variants-wrapper--inner">
                <div v-for="(e, i) in parseInt(cart.product.amount)" v-bind:key="i.id" class="variant" :style="'z-index:' + 100-i + ' ' + 'position:relative'">
                    <div class="variant-image-wrapper">
                        <img :src="cart.variants.color_options[i].image" />
                        <div class="item-number">{{ e }}</div>
                    </div>
                    <div class="color-size-wrapper">
                        <div class="colors " v-on:click="tooltip.color = false">
                            <!-- <div v-if="askForColor && e == 1" class="tooltip tooltip-color">Click Here To Change <span>Color!</span>
                            </div> -->
                            <p class="picker-variant-title"> Color:</p>
                            <!-- <div v-for="value, key in colors" :key="key" class="color"

                                 @click="changeColor(i, key.toLowerCase());"
                                 :style="'background:' + colors[key]['code']">
                                <div class="color-type">{{ key }}</div>
                            </div> -->

                            <div @click.stop>
                                <Multiselect :preselectFirst="true" @input="changeColor(i);" v-model="cart.variants.color_options[i]" label="tr_title" trackBy="sku" :options="colors" :hide-selected="true" :searchable="false" :close-on-select="true" :show-labels="false">
                                    <template v-slot:singleLabel="props">
                                        <div class="color-box" style="display:flex;">
                                            <span v-if="props.option.sku === 'white'" class="color-box__color" style="border:1px solid #dcdcdc;" :style="'background-color:' + props.option.color_code"> </span>
                                            <span v-else class="color-box__color" :style="'background-color:' + props.option.color_code"> </span>
                                            <span class="color-box__name">{{ props.option.tr_title }}</span>
                                        </div>
                                    </template>
                                    <template v-slot:option="props" >
                                        <div class="color-box" style="display:flex;">
                                            <span v-if="props.option.sku === 'white'" class="color-box__color" style="border:1px solid #dcdcdc;" :style="'background-color:' + props.option.color_code"> </span>
                                            <span v-else class="color-box__color" :style="'background-color:' + props.option.color_code"> </span>
                                            <span class="color-box__name">{{ props.option.tr_title }}</span>
                                        </div>
                                    </template>
                                </Multiselect>
                            </div>
                        </div>


                        <div class="sizes" v-on:click="tooltip.size = false">
                            <!-- <div v-if="askForSize && e == 1" class="tooltip">Click Here To Change <span>Size!</span>
                            </div> -->
                            <p class="picker-variant-title">Size:</p>
                            <div @click.stop>
                                <multiselect :preselect-first="true" v-model="cart.variants.size_options[i]" :options="sizes" label="size_title" :hide-selected="true" :searchable="false" :close-on-select="true" :show-labels="false" @input="changeSize(i)"></multiselect>
                            </div>
                        </div>


                    </div>
                </div>
                <!-- <div v-if="askForSize" class="tooltip">Click Here To Change <span>Size!</span></div>

                <div class="size-chart-img">
                    <img :src="sizeChart()" alt="" srcset="" width="100%" height="auto">
                </div> -->
            </div>
        </div>
    </transition>
</template>

<script setup>
import {ref, onMounted, nextTick} from 'vue';
import Multiselect from 'vue-multiselect'
import {useCartStore} from "../state/cart";

const props = defineProps({
    variants: Object,
    activeProduct: Number,
    current: Number
})

const cart = useCartStore();

const showPicker = ref(true);
const askForVariants = ref(false);
const colors = ref([]);
const sizes = ref([]);

if (props.variants.color_options.enable_variant_color) {
    colors.value = Object.values(props.variants.color_options.colors)
}

if (props.variants.size_options.enable_variant_size) {
    sizes.value = Object.values(props.variants.size_options.sizes)
}

onMounted(() => {
    cart.setInitialVariants();

    if (!cart.initialSet) {
        askForVariants.value = true;
    }
})


function modalWindow() {
    console.log('modal');
}

function productColor() {
    let equal = false;
    // let equal = Object.values(cart.selectedColors).slice(0, parseInt(this.activeProduct.amount)).every((val, i, arr) => val === arr[0])
    return equal;
}
function productSize() {
    let equal = false;

    // let equal = Object.values(this.activeProduct.selectedSizes).slice(0, parseInt(this.activeProduct.amount)).every((val, i, arr) => val === arr[0])
    return equal;
}
</script>


<style scoped lang="scss">

.colors.header .color {
    width: 20px;
    height: 20px;
    border-radius: 6px;
    border: solid 1px #fff;
}

.rotate {
    transform: rotate(180deg);
}

.list-enter,
.list-leave-to {
    visibility: hidden;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
}

.list-enter-active,
.list-leave-active {
    transition: all 0.3s;
}

//super custom size-picker 3000

@mixin breakpoint-w($width) {
    @media screen and (max-width: $width) {
        @content;
    }
}

.picker-variant-title {
    margin-right: 10px;
    @include breakpoint-w(530px) {
        margin-right: 10px;
    }
    @include breakpoint-w(420px) {
        min-width: 41px;
    }
}

.variants-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: #FFFFFF;
    z-index: 100;
    position:relative;
    .size-box-toggle {
        text-align:center;
        color: #fff;
        cursor: pointer;
        @include breakpoint-w(420px) {
            margin-bottom: 5px;
        }
    }

    .color-size-wrapper {
        width: 100%;
        display: flex;
        justify-content: space-between;
        @media screen and (max-width: 991px){
            justify-content: space-around;
        }
        @include breakpoint-w(420px) {
            width: auto;
            flex-direction: column;
            align-items: self-start;
        }
    }

    .variant-title {
        display: flex;
        justify-content: space-between;
        align-items:center;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        padding: 10px 15px;
        background-color: #c7e4fd;
        width: 100%;
        transition: background-color 0.2s ease, color 0.2s ease;
        @include breakpoint-w(420px) {
            align-items: center;
            flex-direction: column;
        }

        .variant-title-picked {
            color: #fff;
            display: flex;

            .picked-color {
                display: flex;
                margin-right: 20px;

                p {
                    margin-right: 5px;
                    text-decoration: none;
                }

                .header {
                    text-decoration: underline;
                }
            }

            .picked-size {
                display: flex;

                p {
                    margin-right: 5px;
                    text-decoration: none;

                }

                .sizes {

                    text-decoration: underline;

                    .not-mixed {
                        text-transform: uppercase;
                    }
                }
            }
        }

        img {
            margin-left: 5px;
        }


        .stchevron {
            fill: #000000;
            transition: fill 0.2s ease;

        }


        background-color: #DC624E;
        color: #fff;


        .stchevron {
            fill: #fff;
        }

    }

    .variants-wrapper--inner {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        position: relative;
        z-index: 0;


        .tooltip {
            white-space: nowrap;
            position: absolute;
            top: -40px;
            right: 16px;
            @include breakpoint-w(420px) {
                display: none;
            }

            &.tooltip-color {
                right: 12px;
                @include breakpoint-w(530px) {
                    right: -20px;
                }

                &.variants {
                    display: none;
                    @include breakpoint-w(420px) {
                        display: block;
                    }
                }

            }


            background-color: #960101;
            color: #fff;
            border: 1px solid #e0e0e0;
            box-shadow: 1px 1px 1px #d2d2d2;
            border-radius: 4px;
            z-index: 1;
            opacity: 1;
            padding: 5px 10px;
            font-size: 12px;

            @include breakpoint-w(530px) {
                right: -15px;
                font-size: 10px;
            }

            span {
                font-weight: 700;
            }


            &::before {
                content: '';
                width: 10px;
                height: 10px;
                background-color: #960101;

                box-shadow: 1px 1px 1px #d2d2d2;
                bottom: -6px;
                left: 55%;
                position: absolute;
                transform: translate(-50%, 0) rotate(45deg);
                z-index: -1;
            }


        }


        .variant {

            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 10px 15px;


            &:nth-of-type(odd) {
                background-color: #e0e0e038;

            }


            .variant-image-wrapper {
                position: relative;
                margin-right: 25px;
                width: 50px;
                height: auto;
                @include breakpoint-w(530px) {
                    margin-right: 15px;
                }


                .item-number {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 23px;
                    height: 23px;
                    padding: 2px;
                    background: #fffffff2;
                    border: 1px solid #dcdcdc;
                    font-size: 12px;
                    border-radius: 50%;
                    color: #5a5a5a;
                    text-align: center;
                    font-weight: 500;
                }
            }

            .sizes {
                position: relative;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;


                .size {

                    background-color: #fff;
                    border: 1px solid #e0e0e0;
                    box-shadow: 1px 1px 1px #d2d2d2;
                    cursor: pointer;
                    position: relative;
                    width: 50px;
                    height: 40px;
                    border-radius: 4px;
                    position: relative;
                    top: 0;
                    transition: background-color 0.2s ease, box-shadow 0.2s ease, color 0.2s ease, top 0.2s ease;


                    &:not(:nth-last-child(1)) {
                        margin-right: 10px;
                    }

                    @include breakpoint-w(530px) {
                        width: 32px;
                        height: 30px;
                        &:not(:nth-last-child(1)) {
                            margin-right: 8px;
                        }
                    }

                    .size-type {
                        position: absolute;
                        transform: translate(-50%, -50%);
                        top: 50%;
                        left: 50%;
                        font-size: 14px;
                        line-height: 16px;
                        font-weight: 600;


                        @include breakpoint-w(530px) {
                            font-size: 12px;
                            line-height: 12px;
                        }

                    }


                    &.active {
                        background-color: #fff;
                        border: 3px solid #CC1212;


                        &:hover {
                            background-color: #dadada;
                            border: 3px solid #CC1212;


                            .size-type {
                                color: #fff;
                            }
                        }
                    }


                    &:hover {
                        top: 1px;
                        background-color: #bbb;
                        border: 1px solid #bbb;

                        .size-type {
                            color: #fff;
                        }
                    }


                }

            }

            .colors {
                position: relative;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                margin-left:40px;
                margin-right: 5px;

                @media screen and (max-width: 991px){
                    margin-left:0px
                }
                @include breakpoint-w(420px) {
                    margin-bottom: 20px;
                }

                .color {
                    background-color: #fff;
                    border: 1px solid #e0e0e0;
                    box-shadow: 1px 1px 1px #d2d2d2;
                    cursor: pointer;
                    position: relative;
                    width: 40px;
                    height: 40px;
                    border-radius: 4px;
                    top: 0;
                    transition: background-color 0.2s ease, box-shadow 0.2s ease, color 0.2s ease, top 0.2s ease;

                    &:not(:nth-last-child(1)) {
                        margin-right: 10px;
                    }

                    @include breakpoint-w(530px) {
                        width: 30px;
                        height: 30px;
                        &:not(:nth-last-child(1)) {
                            margin-right: 8px;
                        }
                    }

                    .color-type {
                        position: absolute;
                        transform: translate(-50%, -50%);
                        top: 50%;
                        left: 50%;
                        font-size: 16px;
                        line-height: 16px;
                        font-weight: 600;
                        @include breakpoint-w(530px) {
                            font-size: 12px;
                            line-height: 12px;
                        }
                    }

                    &.active {
                        position: relative;
                        background-color: #CC1212;
                        border: 3px solid #CC1212;
                        color: #fff;

                        &::after {
                            display: block;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            z-index: 2;
                            content: '';
                            width: 14px;
                            height: 14px;
                            background: url('/swatch/checkmark.svg');
                            background-position: center; /* Center the image */
                            background-repeat: no-repeat; /* Do not repeat the image */
                            background-size: cover;
                        }
                    }

                    &:hover {
                        background-color: #CC1212;
                        border: 3px solid #CC1212;
                        top: 1px;

                        .size-type {
                            color: #fff;
                        }
                    }


                }

                /*&:hover {
                    top: 1px;
                    background-color: #bbb;
                    border: 1px solid #bbb;

                    .size-type {
                        color: #fff;
                    }
                }*/
            }
        }
    }
}

.size-chart-img {
    width: 100%;
    padding: 10px;
}

//super custom size-picker 3000 end
</style>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style lang="scss"  scoped>
                        /* Custom vue-select and size chart styles */
                    .multiselect{
                        width:115px;
                        height: 32px;

                        &__single{
                            font-weight: 400;
                            font-size: 14px;
                        }
                    }

.color-box{
    display:flex;
    align-items: center;

    &__color{
        width: 12px;
        height: 12px;
        margin-right: 4px;
        border-radius: 50%;
    }
    &__name{
        color:#333;
        font-size: 14px;
        text-transform: capitalize;
    }

}
.chart{
    display:flex;
    text-align:center;
    align-items: center;

    @media screen and (max-width: 420px){
        margin-bottom: 5px;
    }

    &__image{
        margin-right: 5px;
    }

    &__text{
        margin-right:5px;
        text-decoration: underline;
    }
}
</style>

<style >
/* For some reason custom vue-select classes work only here with no scope */
.multiselect__element .multiselect__option--highlight {
    background: #f2f9fd !important;
    color: #35495E;
    cursor: pointer;
}

/* .multiselect__select:before{
    background-image: url(./Vector.svg);
    width:14px;
    height: 8px;

} */
</style>